import { createContext, useState } from 'react';
import { useToast } from '../antd/hooks/toast';
import { GetCompany, ShowTenant } from '../API/CompaniesAPI';
import { IChildrenProps } from '../Interfaces/IChildrenProps';
import { IResponseProps } from '../Interfaces/IResponseProps';
import { CompanyModel } from '../Models/CompanyModel';
import { useAuth } from "oidc-react";


interface ICompanyProps {
    company: CompanyModel,
    getCompany: (id: string) => Promise<void>,
    showTenant: (id: string, alternancy: boolean) => Promise<void>
}

export const CompanyContext = createContext({} as ICompanyProps);

const CompanyContextProvider = ({ children }: IChildrenProps) => {
    const toast = useToast();
    const auth = useAuth();
    let userData = useAuth()?.userData;

    const [company, setCompany] = useState<CompanyModel>(() => {
        const company = JSON.parse(sessionStorage.getItem("company") ?? "{}");

        if (company) {
            return company;
        }

        return {} as CompanyModel
    });

    // const getCompany = async (id: string) => {
    //     try {
    //         await GetCompany(id).then((resp: IResponseProps) => {
    //             if (resp.statusCode == 200) {
    //                 setCompany(resp.data);
    //                 sessionStorage.setItem("company", JSON.stringify(resp.data));
    //             }
    //         });
    //     } catch (error: any) {
    //         toast.error(error);
    //     }
    // }

    const getCompany = async (id: string) => {
        try {
            const companyData = await GetCompany(id);
            setCompany(companyData.data);
            sessionStorage.setItem("company", JSON.stringify(companyData.data));
            return companyData;
        } catch (error) {
            console.error("Falha ao buscar empresa:", error)
            throw error;
        }
    }

    const showTenant = async (id: string, alternancy: boolean) => {
        try {
            await ShowTenant(id, alternancy).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    setCompany(resp.data);
                    sessionStorage.setItem("company", JSON.stringify(resp.data));
                }
            });
        } catch (error: any) {
            toast.error(error);
        }
    }

    return (
        <>
            {auth && userData &&
                <CompanyContext.Provider value={{ company, getCompany, showTenant }}>
                    {children}
                </CompanyContext.Provider>
            }
        </>
    )
}

export default CompanyContextProvider;
